import { Subject, Observable } from 'rxjs';
import { take } from 'rxjs/operators';

export class ModalRef<R = unknown> {
  private readonly _afterClosed = new Subject<R | undefined>();
  readonly afterClosed$: Observable<R | undefined> = this._afterClosed.asObservable().pipe(take(1));

  private _closed = false;

  componentInstance: any;

  /** @internal */
  _destroy: () => void = () => {};

  close(result?: R): void {
    if (this._closed) return;
    this._closed = true;
    this._afterClosed.next(result);
    this._afterClosed.complete();
    this._destroy();
  }
}
